import React, { useEffect, useState } from 'react'
import injectSheet from 'react-jss'
import Button from 'pobble-components/dist/button'
import google from './google.png'
import { initGoogleSDK, googleLogin } from 'pobble-components/dist/oauth'
import {
  redirectAfterAuth,
  setToken
} from 'pobble-components/dist/auth-helpers'
import { withRouter } from 'react-router-dom'
import Spinner from 'pobble-components/dist/spinner'
import { getFinishSignupStatus } from '../../common/api/me.selectors'
import EVENTS from '../../events'
import { useFeatureFlagVariantKey } from 'posthog-js/react'
import { REDIRECT_AFTER_AUTH_FLAG } from '../../common/redirect-after-auth-flag'

export const GoogleOauth = withRouter(
  injectSheet({
    button: {
      background: '#fff',
      color: 'var(--gray)',
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      borderColor: '#CDCDCD',
      '& > div': {
        height: '16px !important'
      },
      '&:hover, &:focus': {
        background: '#fff',
        borderColor: '#999'
      }
    },
    icon: {
      width: '16px',
      height: '16px'
    },
    spinner: {
      fontSize: '14px',
      color: 'var(--gray--)',
      height: '1em !important',
      width: '1em !important'
    }
  })(({ classes, history }) => {
    const [loading, setLoading] = useState(false)
    const redirectVariant = useFeatureFlagVariantKey(REDIRECT_AFTER_AUTH_FLAG)

    useEffect(() => {
      initGoogleSDK()
    }, [])

    function login() {
      setLoading(true)
      googleLogin()
        .then(res => {
          if (!res || !res.data || !res.data.jwt) return
          setToken(res.data.jwt)
          const FSUStatus = getFinishSignupStatus(res.data)

          EVENTS.onOauthSignin({ provider: 'google' }).then(res => {
            !FSUStatus.finished
              ? history.push('/finish-signup')
              : redirectAfterAuth(redirectVariant === 'test')
          })
        })
        .catch(() => {
          setLoading(false)
        })
    }

    return (
      <Button
        disabled={loading}
        action={login}
        className={`${classes.button} metrics__oauth--google`}
        tall
        icon={
          !loading ? (
            <img className={classes.icon} src={google} alt="Google" />
          ) : (
            <Spinner className={classes.spinner} />
          )
        }>
        {loading && 'Signing in with Google...'}
        {!loading && 'Continue with Google'}
      </Button>
    )
  })
)
